import { CalledsService } from './../../../auth/_services/calleds.service';
import { Called } from './../../../auth/_models/called';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-called-detail',
  templateUrl: './called-detail.component.html',
  styleUrls: ['./called-detail.component.css']
})
export class CalledDetailComponent implements OnInit {

  called: Called = null;

  constructor(
    private _service: CalledsService
  ) { }

  ngOnInit() {
    this._service.eventSelectCalled.subscribe(
      resp => {
        this.called = resp;
      }
    );
  }

}
